import React from "react";
import { partners } from "../data/mock";

const Partners = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-14 max-w-3xl mx-auto">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] mb-4 px-3 py-1 rounded-full bg-emerald-100 text-emerald-700">
            Our Network
          </span>
          <h2
            className="text-3xl md:text-5xl font-bold mb-5 tracking-tight"
            style={{ color: "#0a2e1f" }}
          >
            A Trusted Partner of Renowned Manufacturers
          </h2>
          <p className="text-slate-600 leading-relaxed">
            D-H Gadiola is your trusted source for top-quality products and
            unmatched expertise. Benefit from our commitment to quality
            assurance, exceptional customer service, and a streamlined supply
            chain.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {partners.map((partner, idx) => (
            <div
              key={idx}
              className="group relative aspect-[4/3] rounded-2xl flex items-center justify-center bg-white border border-slate-100 hover:border-emerald-200 hover:shadow-xl hover:shadow-emerald-500/10 hover:-translate-y-1 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(16,185,129,0.06) 0%, rgba(52,211,153,0.03) 100%)",
                }}
              />
              <div className="relative flex flex-col items-center justify-center text-center px-3">
                <div
                  className="text-3xl md:text-4xl font-extrabold mb-1 tracking-tight bg-clip-text text-transparent"
                  style={{
                    backgroundImage:
                      "linear-gradient(135deg, #0a2e1f 0%, #047857 100%)",
                  }}
                >
                  {partner.short}
                </div>
                <div className="text-[10px] uppercase tracking-widest font-semibold text-slate-500 group-hover:text-emerald-700 transition-colors">
                  {partner.name}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
